module.exports = __webpack_public_path__ + "img/lasource-5.fe1d98fb.jpg";